import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloudDownloadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cloud_download"}/>
}
